/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState, memo } from 'react';
// import classNames from 'classnames';
import Caption from '../Caption/Caption';
import Icons from '../../../configs/icon.config';

interface ListItemProps {
  isTitle?: boolean;
  caption_en?: string;
  caption_bn?: string;

  captionColor?: string;
  captionSize?: string;
  captionWeight?: string;
  link?: string;
  hasBadge?: boolean;
  hasNavlink?: boolean;
  isActive?: boolean;
  icon?: string;
  iconColor?: string;
  badgeColor?: string;
  extraFeature?: React.ReactNode;
  classname?: string;
  styles?: React.CSSProperties;
  children?: any[];
  onClick?: () => void;
  iconsize?: string;
  iconcolor?: string;
  contacType?: string;
  target?: boolean;
}

function ListItem({
  caption_en,
  caption_bn,
  captionColor,
  captionSize,
  captionWeight,
  link,
  onClick,
  icon,
  iconColor,
  iconsize,
  extraFeature,
  iconcolor,
  target = false,
  // classname,
  // styles,
  contacType,
}: ListItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [active, setActive] = useState(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
    setActive(!active);
    onClick?.();
  };

  // const ListItemStyle = {
  //     ...styles,
  // };
  // const classes = classNames('list-item', classname);

  return (
    <li className="list-none">
      <div className="flex flex-row justify-between mb-2 ">
        <div className="flex flex-row">
          {contacType === 'phone' || contacType === 'email' ? (
            <a
              href={
                contacType === 'phone'
                  ? `tel:${caption_en}`
                  : `mailto:${caption_en}`
              }
            >
              <div style={{ fontSize: iconsize, color: iconcolor }}>
                {icon && (
                  <div className={`mr-3 ${iconColor}`}>{Icons[icon]}</div>
                )}
              </div>
            </a>
          ) : (
            <div style={{ fontSize: iconsize, color: iconcolor }}>
              {icon && <div className={`mr-3 ${iconColor}`}>{Icons[icon]}</div>}
            </div>
          )}

          {link ? (
            <a
              href={link}
              target={target ? '_blank' : '_self'}
              rel="noreferrer"
            >
              <div className="cursor-pointer" onClick={handleToggle}>
                <Caption
                  text_en={caption_en}
                  text_bn={caption_bn}
                  color={captionColor}
                  fontSize={captionSize}
                  fontWeight={captionWeight}
                />
              </div>
            </a>
          ) : (
            <div className="" onClick={handleToggle}>
              <Caption
                text_en={caption_en}
                text_bn={caption_bn}
                color={captionColor}
                fontSize={captionSize}
                fontWeight={captionWeight}
              />
            </div>
          )}
        </div>
        <div className="">
          {extraFeature && <div className=" ">{extraFeature}</div>}
        </div>
      </div>
    </li>
  );
}

ListItem.defaultProps = {
  caption_en: 'Hello-World',
  hasBadge: true,
  hasNavlink: false,
  isActive: false,

  badgeColor: '#d10d74',
  extraFeature: false,
};

export default memo(ListItem);
